export default __webpack_public_path__ + "static/media/marauders-map-v0-02-01.a36e9809.jpg";